<template>
    <div class="w-full">
        <el-card class="m-6" shadow="none">
            <div slot="header" class="clearfix">
                <span class="leading-loose">{{ cardTitle }}</span>
                <el-button type="primary" size="medium" class="float-right" icon="el-icon-plus" @click="handleAdd()">Toevoegen</el-button>
            </div>

            <el-table :data="tableData"
                      class="w-full"
                      @sort-change="sort"
                      :default-sort = "{prop: 'id', order: 'ascending'}">

                <!-- Image -->
                <el-table-column
                        sortable="custom"
                        prop="url"
                        label="Foto"
                        width="150">
                    <template slot-scope="scope">
                        <el-popover
                                placement="top"
                                width="200"
                                trigger="hover">
                            <el-image :src="resolve(scope.row.attachment.url)"
                                      fit="cover"></el-image>
                            <el-image slot="reference"
                                    style="width: 80px; height: 80px"
                                    :src="resolve(scope.row.attachment.url)"
                                    fit="cover"></el-image>
                        </el-popover>
                    </template>
                </el-table-column>

                <!-- Tak -->
                <el-table-column
                        sortable="custom"
                        prop="branchId"
                        label="Tak"
                        width="180">
                    <template slot-scope="scope">
                        <el-tag>{{ getBranchName(scope.row.branchId) }}</el-tag>
                    </template>
                </el-table-column>

                <!-- Operations column -->
                <el-table-column label="Operaties">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">Wijzigen</el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">Verwijderen</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination class="mt-6"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="currentPage"
                           :page-sizes="pageSizes"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="totalElements">
            </el-pagination>
        </el-card>

        <image-dialog ref="addEditDialog" :branch-options="branchOptions"></image-dialog>
    </div>
</template>

<script>
    import ImageDialog from "./dialogs/ImageDialog";
    export default {
        name: "Images",
        components: {ImageDialog},
        data() {
            return {
                // Title
                cardTitle: "Foto's",
                itemName: "foto",
                branchOptions: this.getBranchOptions(),

                // Table data
                tableData: this.getList(),
                numPages: 1,
                pageSize: 10,
                currentPage: 1,
                pageSizes: [10, 20, 50],
                totalElements: 0
            }
        },
        methods: {
            handleSizeChange() {
                this.getList();
            },
            handleCurrentChange() {
                this.getList();
            },
            handleDelete(index, obj) {
                this.$confirm(`Het verwijderen van een ${this.itemName} is een actie die niet ongedaan kan worden gemaakt. Bent u zeker dat u deze ${this.itemName} wil verwijderen?`, `${this.capitalize(this.itemName)} verwijderen`, {
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleer',
                    customClass: "p-4",
                }).then(() => {
                    this.$http.delete(`admin/photos/${obj.id}`).then((response) => {
                        this.$notify({
                            title: `${this.capitalize(this.itemName)} verwijderd`,
                            message: `${this.capitalize(this.itemName)} werd successvol verwijderd.`,
                            type: 'success'
                        });
                        this.getList();
                    }).catch((error) => {
                        this.$message({
                            showClose: true,
                            message: `Kon ${this.itemName} niet verwijderen`,
                            type: 'error'
                        });
                        console.log(error);
                    })
                })
            },
            handleEdit(index, row) {
                this.$refs.addEditDialog.edit(row)
            },
            handleAdd() {
                this.$refs.addEditDialog.add()
            },
            objAdded(obj) {
                // Add API call here
                this.$http.post('admin/photos', obj).then((response) => {
                    this.$notify({
                        title: `${this.capitalize(this.itemName)} toegevoegd`,
                        message: `${this.capitalize(this.itemName)} werd successvol toevoegd.`,
                        type: 'success'
                    });
                    this.$refs.addEditDialog.close();
                    this.getList();
                }).catch((error) => {
                    this.$refs.addEditDialog.openAlert(`Kon ${this.itemName} niet toevoegen`, 'error')
                    console.log(error);
                })
            },
            objEdited(obj) {
                // Add API call here
                this.$http.put(`admin/photos/${obj.id}`, obj).then((response) => {
                    this.$notify({
                        title: `${this.capitalize(this.itemName)} gewijzigd`,
                        message: `${this.capitalize(this.itemName)} werd successvol gewijzigd.`,
                        type: 'success'
                    });
                    this.$refs.addEditDialog.close();
                    this.getList();
                }).catch((error) => {
                    this.$refs.addEditDialog.openAlert(`Kon ${this.itemName} niet wijzingen`, 'error')
                    console.log(error);
                })
            },
            getBranchOptions() {
                const that = this
                this.$http.get('admin/branches/list').then((response) => {
                    this.branchOptions = response.data;
                }).catch(function (error) {
                    if(error.response.status === 403) {
                        that.$router.replace({ name: 'Login', force: true });
                    }
                    this.branchOptions = [];
                    console.log(error)
                })
            },
            getBranchName: function (id) {
                if(this.branchOptions) {
                    const branch = this.branchOptions.find(function(branch) {
                        return branch.id === id;
                    });

                    return branch.label
                }
            },
            sort (props) {
                if (props.order === 'ascending') {
                    this.sortDir = 'ASC'
                } else {
                    this.sortDir = 'DESC'
                }
                this.sortBy = props.prop
                this.getList()
            },
            getList() {
                const that = this
                let params = {}
                params['numPerPage'] = this.pageSize
                params['page'] = this.currentPage
                if (this.sortDir != null && this.sortBy != null) {
                    params['sortBy'] = this.sortBy
                    params['sortDir'] = this.sortDir
                }

                this.$http.get('admin/photos', {
                    params: params
                }).then((response) => {
                    const listResponse = response.data.content
                    this.tableData = listResponse;
                    this.totalElements = response.data.totalElements
                }).catch(function (error) {
                    if(error.response.status === 403) {
                        that.$router.replace({ name: 'Login', force: true });
                    }
                    console.log(error)
                })
            },
            resolve(img) {
                return this.$http.defaults.baseURL + 'resources/' + img
            },
            capitalize(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/images/Images.vue